import PropTypes from 'prop-types';
import React from 'react';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import { modelNameTransformer } from 'pubweb-smokey/dist/utils/modelNameTransformer';
import Button from '@components/Shared/Buttons/Button';
import { StickyNavStyles } from './StickyNav.styled';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

const StickyNav = ({
  homeDetails,
  onRequestInfoClick,
  onFindRetailerClick,
  onFeaturesClick,
  epicSlug,
}) => {
  const ctaHandler = React.useCallback(() => {
    if (onRequestInfoClick) {
      onRequestInfoClick();
    }

    if (epicSlug) {
      pushGTMEvent('gtm-chcom-dx-home-details-click', 'dx_home_details_click', {
        location: 'Home Details',
        category: 'home_consideration',
        action: 'button',
        label: 'dx_home_details_click',
      });

      window.open(
        `https://epic.claytonhomes.com/customize/?modelId=${epicSlug}`,
        '_blank'
      );
    }
  }, [epicSlug, onRequestInfoClick]);

  return (
    <StickyNavStyles>
      <div>
        <div className="favoriting-heart-container">
          <DXFavoritesContext.Consumer>
            {({ state, actions }) => {
              return (
                <FavoritingHeart
                  isFavorited={
                    !!state.favoriteModels?.filter(
                      (faveModels) =>
                        faveModels.modelNumber === homeDetails.modelNumber
                    )[0]
                  }
                  onClick={() => {
                    actions.toggleFavoriteModel(homeDetails.modelNumber);
                    pushGTMEvent('clickFavoritesHeart');
                  }}
                />
              );
            }}
          </DXFavoritesContext.Consumer>
        </div>
        <div className="sticky-description">
          {modelNameTransformer(homeDetails.modelDescription)}
        </div>

        {homeDetails.tags && homeDetails.tags.length > 0 && (
          <div className="sticky-links">
            <a
              onClick={() => {
                onFeaturesClick();
                pushGTMEvent('featuresClick');
              }}
            >
              Features
            </a>
          </div>
        )}

        <div className="sticky-buttons">
          <Button
            automationId="find-retailer-click"
            className="find-retailer-button"
            isCompact={true}
            onClick={onFindRetailerClick}
          >
            Find A Retailer
          </Button>
          <Button
            automationId="request-info-click"
            className="request-info-button"
            isCompact={true}
            onClick={ctaHandler}
          >
            {epicSlug ? 'Design Online' : 'Request Info'}
          </Button>
        </div>
      </div>
    </StickyNavStyles>
  );
};

StickyNav.propTypes = {
  epicSlug: PropTypes.any,
  homeDetails: PropTypes.shape({
    modelDescription: PropTypes.any,
    modelNumber: PropTypes.any,
    tags: PropTypes.any,
  }),
  onFeaturesClick: PropTypes.func,
  onFindRetailerClick: PropTypes.any,
  onRequestInfoClick: PropTypes.func,
};

export default StickyNav;
